<div>
	<div
		kendoTypography
		variant="h4"
		class="title">
		Employee Dashboard
	</div>
	<div class="content">
		<kpa-announcements-card
			[isDashboard]="true"
			[announcements]="recentAnnouncements"></kpa-announcements-card>
		<kendo-tabstrip style="margin-top: 24px">
			<kendo-tabstrip-tab
				[title]="'Open Tasks'"
				[selected]="true">
				<ng-template kendoTabContent>
					<kpa-opentasks></kpa-opentasks>
				</ng-template>
			</kendo-tabstrip-tab>
			<kendo-tabstrip-tab [title]="'Completed Tasks'">
				<ng-template kendoTabContent>
					<kpa-completedtasks></kpa-completedtasks>
				</ng-template>
			</kendo-tabstrip-tab>
		</kendo-tabstrip>
	</div>
</div>
